import { Modal } from 'flowbite-react';
import React from 'react';
import { Loader } from 'ui';

interface Props {
	isOpen: boolean;
}

const LiveInterviewOverlayModal = ({ isOpen }: Props) => {
	return (
		<Modal className="live-interview-overlay-modal" show={isOpen}>
			<Modal.Body>
				<Loader />
				<p className="text-center mt-2">Please wait while we are submitting your response...</p>
			</Modal.Body>
		</Modal>
	);
};

export default LiveInterviewOverlayModal;
